import React from 'react'
import { CardWithImage } from '../../elements/CardWithImage'
import { HeadingBlock } from '../HeadingBlock'
import { containerMaxWidth, mq } from '../../utils'
import { IProps } from './index'

import { CardsWithImage as CardsWithImageDefault } from './component'
import { BrandOptions, useBrand } from '../../providers/brandProvider'

export const CardsWithImage: React.FC<IProps> = (props: IProps) => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <CardsWithImageDefault {...props} />
  }
  return <CardsWithImageLegacy {...props} />
}

const CardsWithImageLegacy: React.FC<IProps> = ({ title, cards }) => {
  return (
    <div className="card-with-image-list">
      {title ? (
        <div className="card-with-image-title">
          <HeadingBlock text={title} />
        </div>
      ) : null}
      <ul className="content">
        {cards.map((card, index) => (
          <li key={index}>
            <CardWithImage {...card} />
          </li>
        ))}
      </ul>
      <style jsx>
        {`
          .card-with-image-list {
            display: grid;
            grid-template-columns: [left-gutter] 1fr [content] 12fr [right-gutter] 1fr;
          }

          .card-with-image-title {
            grid-column: 2/3;
            margin-bottom: 1rem;
          }

          .content {
            grid-column: content;
            justify-self: center;
            align-content: start;
          }

          .card-wrapper {
            max-width: 400px;
            padding-bottom: 60px;
          }

          @media (${mq.tablet}) {
            .content {
              display: grid;
              max-width: ${containerMaxWidth};
              grid-template-columns: repeat(3, 1fr);
              grid-column-gap: 36px;
            }
            .card-with-image-title {
              grid-column: 2/3;
              margin-bottom: 2rem;
            }
          }
        `}
      </style>
    </div>
  )
}
